import { connect } from 'react-redux'
import { compose } from 'recompose'

import Component from './component'

import withTranslation from '../../../globals/components/withTranslation'

export default compose(
  withTranslation,
  connect((state, props) => {
    const { lang, path } = props.match.params

    return {
      lang,
      path,
      isAuthenticated: !!state.auth.accessToken,
    }
  })
)(Component)
